export default {"src":"/_next/static/media/notifications.09ea3aef.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};